<div
  *ngIf="isVisible()"
  class="solution-area"
  role="region"
  [attr.aria-labelledby]="isSolutionHeaderVisible() ? getHeaderId() : null"
  [attr.aria-label]="isSolutionHeaderVisible() ? null : getText('lbl_solution')"
  (mouseenter)="audioTrigger.next(true)"
 data-ui-name="Correct answer / Txt colon" data-ui-component="element-render-solution" data-testid="element-render-solution-correct-answer-txt-colon">
  <div style="border:1px solid #ccc; margin-top:2em;"></div>
  <div  class="solution-container">
    <div class="solution-header" *ngIf="isSolutionHeaderVisible()" [id]="getHeaderId()">
      <tra slug="lbl_correct_answer"></tra><tra slug="txt_colon"></tra>
    </div>
    <div *ngFor="let contentElement of element.content">
      <element-render
        [contentElement]="contentElement" 
        [questionState]="questionState" 
        [isLocked]="isLocked"
        [questionPubSub]="questionPubSub"
       data-ui-name="Element render" data-ui-component="element-render-solution" data-testid="element-render-solution-element-render"></element-render>
    </div>

  </div>
</div>
<render-audio
[url]="element.voiceover?.url || ''"
[trigger]="audioTrigger"
[isTriggerDisabled]="!isVoiceoverEnabled()"
 data-ui-name="Render audio" data-ui-component="element-render-solution" data-testid="element-render-solution-render-audio"></render-audio>
